import { useEffect } from 'react';

/**
 * ESC 키를 눌렀을 때 콜백 함수를 실행하는 Hook
 * 모달, 팝업 등에서 ESC 키로 닫기 기능을 구현할 때 사용
 * 
 * @param onEscape - ESC 키를 눌렀을 때 실행할 콜백 함수
 * @param isEnabled - Hook 활성화 여부 (기본값: true)
 * 
 * @example
 * ```tsx
 * const [isOpen, setIsOpen] = useState(false);
 * useEscapeKey(() => setIsOpen(false), isOpen);
 * ```
 */
export function useEscapeKey(onEscape: () => void, isEnabled: boolean = true): void {
  useEffect(() => {
    if (!isEnabled) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onEscape();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onEscape, isEnabled]);
}
